import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row" }
const _hoisted_2 = { class: "md:col-6 col-12" }
const _hoisted_3 = { class: "md:col-6 col-12" }

import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useTenantStore } from '@/store';
import General from './General.vue';
import { LocationForm } from '@/components/Forms';
import { storeToRefs } from 'pinia';
import { LocationFormInterface, TenantPayloadInterface } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const tenantStore = useTenantStore();
const toast = useToast();
const { tenant } = storeToRefs(tenantStore);

const onSaveGeneral = async (name: string) => {
  if (tenant?.value) {
    tenant.value.name = name;
    await tenantStore.updateTenant(payload.value as TenantPayloadInterface);
    doToast();
  }
};

const onSaveLocation = async (location: LocationFormInterface) => {
  if (tenant?.value?.location) tenant.value.location = location;
  await tenantStore.updateTenantLocation(payload.value as TenantPayloadInterface);
  doToast();
};

/**
 * Define the request update payload.
 */
const payload = computed(() => {
  return {
    tenant: tenant?.value,
    location: tenant?.value?.location,
  };
});

/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'Tenant information has been saved',
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(General, { onSave: onSaveGeneral })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(tenant)?.location)
        ? (_openBlock(), _createBlock(_unref(LocationForm), {
            key: 0,
            data: (_unref(tenant).location as LocationFormInterface),
            "permission-to-edit": true,
            "is-organization": false,
            "is-tenant": true,
            class: "location",
            loading: _unref(tenantStore).loading,
            onSave: onSaveLocation
          }, null, 8, ["data", "loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})